const hasReachedCursor = (cursor, target) => {
  const cursorTime = new Date(cursor.createdAt).getTime();
  const targetTime = new Date(target.createdAt).getTime();
  if (cursorTime !== targetTime) return cursorTime < targetTime;
  return String(cursor.id) <= String(target.id);
};

export const shouldContinueActivityFetch = ({
  loadThroughUnexpired,
  reachedOldestUnexpired,
  reconcile,
  nextOffset,
  reconcileThroughOffset,
  oldestLoadedCreatedAt,
  reconcileThroughCreatedAt,
  nextCursor,
  reconcileThroughCursor,
  canFetchNextPage,
}) => {
  if (!canFetchNextPage) return false;
  const needsActionableCoverage = loadThroughUnexpired && !reachedOldestUnexpired;
  let needsExistingCoverage = false;
  if (reconcile) {
    if (nextCursor && reconcileThroughCursor) {
      needsExistingCoverage = !hasReachedCursor(nextCursor, reconcileThroughCursor);
    } else if (reconcileThroughCreatedAt) {
      needsExistingCoverage = !oldestLoadedCreatedAt
        || new Date(oldestLoadedCreatedAt) > new Date(reconcileThroughCreatedAt);
    } else {
      needsExistingCoverage = nextOffset < reconcileThroughOffset;
    }
  }
  return needsActionableCoverage || needsExistingCoverage;
};
